/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useCallback } from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags';
import { Anchor } from '@atlaskit/primitives/compiled';
import { HoverCard } from '@atlaskit/smart-card/hover-card';

import { onJiraIssueKeyClicked } from '../../../../../ai-answer-dialog/analytics';
import type { NonGenerativeAIAnswerResultShownProps } from '../../../../../ai-answer-dialog/types';
import { SainAction } from '../../../../../common/controller/analytics/hooks/use-sain-usage';
import { useAnalytics } from '../../../../../common/controller/analytics/use-analytics';

const styles = cssMap({
	noWrap: {
		whiteSpace: 'nowrap',
	},
});

export const IssueKeyNode = ({
	issuekey,
	url,
	analyticsAttributes,
	fireEngagementEvent,
}: {
	issuekey: string;
	url: string;
	analyticsAttributes: NonGenerativeAIAnswerResultShownProps;
	fireEngagementEvent: (sainAction: SainAction) => void;
}) => {
	const [fireAnalyticsEvent] = useAnalytics();

	const onClick = useCallback(() => {
		fireAnalyticsEvent(onJiraIssueKeyClicked({ ...analyticsAttributes, issuekey }));
		if (fg('kd_fix_nl2jql_mau_instrumentation')) {
			fireEngagementEvent(SainAction.JIRA_NL_TO_JQL_WORK_ITEM_CLICKED);
		}
	}, [fireAnalyticsEvent, fireEngagementEvent, analyticsAttributes, issuekey]);

	return (
		<HoverCard url={url}>
			<Anchor
				href={url}
				xcss={styles.noWrap}
				onClick={onClick}
			>
				{issuekey}
			</Anchor>
		</HoverCard>
	);
};
